<div class="modal">
  <fa-icon
    class="modal__close"
    [icon]="['fas', 'times']"
    size="lg"
    title="close"
    (click)="closeDialog()">
  </fa-icon>
      
  <div mat-dialog-content class="text-12 content">

      <img src="assets/images/biodigital-logo.svg" width="190" class="mb-2"/>
      <p class="text-14 text-semibold">The BioDgital Human Platform</p>
      <p>Version 4.0</p>
      <p class="mb-3"><a href="https://wwww.biodigital.com/terms" target="_blank">Terms of Service</a> | <a href="https://wwww.biodigital.com/privacy" target="_blank">Privacy Policy</a></p>

      <p class="mb-4">Software and all 3D models &copy; <span class="text-semibold">BioDigital, Inc 2019.</span> All rights reserved.</p>

      <p class="mb-2">This program is protected by copyright law and international treaties. Unauthorized
      reproduction, distribution, reverse engineering or sale of the software is strictly
      prohibited. This software is not a diagnostic or clinical decision-making tool.
      The medical information is intended for background viewing and general interest.
      Content is asserted neither complete nor error free. Please consult your own licensed
      physician regarding diagnosis and treatment of any medical condition! Please see
      also our full <a href="https://wwww.biodigital.com/terms" target="_blank">Terms of Service.</a></p>

      <p class="mb-2">The BioDigital Human is made possible through the expertise and dedication of our development team,
          advisors, investors and all who pioneered medical education before us. Thank you!
      </p>

      <p class="mb-2">For licensing information contact <span class="text-medium">info@biodigital.com.</span></p>
  </div>
</div>